import { render } from "./PasswordFormIcon.vue?vue&type=template&id=0d41bf88"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__